import { FeatureData } from '../../components/ui/feature-section-with-hoover-effect';
import {
  IconGeometry,
  IconRocket,
  IconBuildingFactory2,
  IconBuildingEstate,
} from '@tabler/icons-react';

const migrationCloudFeatures: FeatureData[] = [
  {
    title: 'Entreprises en transformation numérique',
    description:
      "Migrer vers le cloud avec IT Monkeys vous permet d'abandonner les contraintes matérielles coûteuses.",
    icon: <IconGeometry size={24} />,
    key: 'migrationCloud.features.digitalTransformation'
  },
  {
    title: 'Startups innovantes',
    description:
      'Adaptez vos ressources IT à votre croissance rapide avec un environnement sécurisé, accessible partout.',
    icon: <IconRocket size={24} />,
    key: 'migrationCloud.features.startups'
  },
  {
    title: 'Industriels',
    description:
      'Modernisez votre infrastructure existante grâce au cloud pour améliorer votre compétitivité et votre sécurité.',
    icon: <IconBuildingFactory2 size={24} />,
    key: 'migrationCloud.features.industrial'
  },
  {
    title: 'Collectivités publiques',
    description:
      'Des solutions cloud fiables et sécurisées adaptées aux besoins spécifiques du secteur public.',
    icon: <IconBuildingEstate size={24} />,
    key: 'migrationCloud.features.publicSector'
  },
];

export default migrationCloudFeatures; 